const getLayerProps = require('./getLayerProps');
const getAttributes = require('./getAttributes');
const getGradientsMap = require('./getGradientsMap');
const mapChildrenLeaves = require('./mapChildrenLeaves');
const stringToHTML = require('./stringToHTML');
const setVariationTextFields = require('./setVariationTextFields');
const getVariationTextFields = require('./getVariationTextFields');
const getRootsTextGrowthEnforcement = require('./getRootsTextGrowthEnforcement');
const calculateGrowDimensions = require('./calculateGrowDimensions');
const addPixels = require('./addPixels');
const transformText = require('./transformText');
const getDefaultTextTransformByRole = require('./getDefaultTextTransformByRole');
const getRootsBBox = require('./getRootsBBox');
const getRootPosition = require('./getRootPosition');
const getMultiValueProperty = require('./getMultiValueProperty');
const jsonToHTMLString = require('./jsonToHTMLString');
const getColorsMap = require('./getColorsMap');
const getRootTransform = require('./getRootTransform');
const mergeStyleToAttributes = require('./mergeStyleToAttributes');
const filterLayersByTags = require('./filterLayersByTags');
const fetchImage = require('./fetchImage');
const hasCurvedText = require('./hasCurvedText');
const setMultiValueProperty = require('./setMultiValueProperty');
const deleteMultiValueProperty = require('./deleteMultiValueProperty');
const addOpacityToHex = require('./addOpacityToHex');
const convertColorToRgba = require('./convertColorToRgba');
const convertHexToHsv = require('./convertHexToHsv');
const convertHsvToHex = require('./convertHsvToHex');
const convertHsvToRgb = require('./convertHsvToRgb');
const convertNamedColorToHex = require('./convertNamedColorToHex');
const convertOpacityToHex = require('./convertOpacityToHex');
const convertRgbaToHex = require('./convertRgbaToHex');
const convertRgbToHsv = require('./convertRgbToHsv');
const convertLetterSpacingToEm = require('./convertLetterSpacingToEm');
const getRGBAValues = require('./getRGBAValues');
const isEqualColor = require('./isEqualColor');
const isHexFormat = require('./isHexFormat');
const isRgbFormat = require('./isRgbFormat');
const normalizeColorsMap = require('./normalizeColorsMap');
const normalizeHexColor = require('./normalizeHexColor');
const isAndroidDevice = require('./isAndroidDevice');
const keyPressListener = require('./keyPressListener');
const getOuterBBox = require('./getOuterBBox');
const getRootOuterBBox = require('./getRootOuterBBox');
const marketplace = require('./marketplace');
const createMarkup = require('./createMarkup');
const { KEYS } = require('./keyPressListener/constants');
const { TEXT_TRANSFORM } = require('./transformText/constants');
const { LAYER_TYPES, LAYER_ROLES, ROOT_LAYER_TYPES } = require('./layerTypes');
const validateRequirements  = require('./validateRequirements');
const { SVG_TAGS, GREYLISTED_SVG_TAGS, WHITELISTED_SVG_TAGS, SVG_ATTRIBUTES, UNITS } = require('./constants');

module.exports = {
    getLayerProps,
    getAttributes,
    getGradientsMap,
    mapChildrenLeaves,
    stringToHTML,
    setVariationTextFields,
    getVariationTextFields,
    getRootsTextGrowthEnforcement,
    calculateGrowDimensions,
    addPixels,
    transformText,
    getDefaultTextTransformByRole,
    getRootsBBox,
    getRootPosition,
    getMultiValueProperty,
    jsonToHTMLString,
    getColorsMap,
    filterLayersByTags,
    getRootTransform,
    mergeStyleToAttributes,
    fetchImage,
    hasCurvedText,
    setMultiValueProperty,
    deleteMultiValueProperty,
    addOpacityToHex,
    convertColorToRgba,
    convertHexToHsv,
    convertHsvToHex,
    convertHsvToRgb,
    convertNamedColorToHex,
    convertOpacityToHex,
    convertRgbaToHex,
    convertRgbToHsv,
    convertLetterSpacingToEm,
    getRGBAValues,
    isEqualColor,
    isHexFormat,
    isRgbFormat,
    normalizeColorsMap,
    normalizeHexColor,
    isAndroidDevice,
    keyPressListener,
    getOuterBBox,
    getRootOuterBBox,
    marketplace,
    createMarkup,
    validateRequirements,
    TEXT_TRANSFORM,
    LAYER_TYPES,
    LAYER_ROLES,
    ROOT_LAYER_TYPES,
    WHITELISTED_SVG_TAGS,
    GREYLISTED_SVG_TAGS,
    SVG_TAGS,
    SVG_ATTRIBUTES,
    UNITS,
    KEYS
};
